import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import { services } from '../../mocks/services';

export default function ServicesPage() {
  return (
    <>
      <Header />
      <FloatingCTA />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-brand-dark relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://public.readdy.ai/ai/img_res/1eea38c0d0be5ad1b48b1207922187f8.jpg"
            alt="BBM Services Jacksonville FL services"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-5">
            <div className="h-px w-8 bg-brand-amber" />
            Our Services
            <div className="h-px w-8 bg-brand-amber" />
          </div>
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-5">
            Chimney, Duct &amp; Vent Cleaning in Jacksonville, FL
          </h1>
          <p className="text-white/70 text-xl max-w-2xl mx-auto">
            Three essential home safety services. One certified, trusted team. Serving Jacksonville and surrounding communities since 2010.
          </p>
        </div>
      </section>

      {/* Services detail */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {services.map((service, i) => (
            <div key={service.id} className={`flex flex-col ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}>
              <div className="lg:w-5/12">
                <div className="rounded-2xl overflow-hidden h-80 lg:h-[400px]">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500" />
                </div>
              </div>
              <div className="lg:w-7/12">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl mb-4">
                  <i className={`${service.icon} text-2xl text-brand-amber`} />
                </div>
                <div className="text-brand-amber text-xs font-bold uppercase tracking-widest mb-2">{service.price} · {service.duration}</div>
                <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark mb-3">{service.title}</h2>
                <p className="text-brand-warm-gray text-lg leading-relaxed mb-5">{service.longDesc}</p>
                <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 mb-6 text-sm text-brand-light">
                  <div className="flex gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-brand-amber" />
                    </div>
                    <strong>Safety Note:</strong>&nbsp;{service.safetyNote}
                  </div>
                </div>
                <ul className="grid grid-cols-2 gap-3 mb-7">
                  {service.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-sm text-brand-light">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-brand-amber" />
                      </div>
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="flex gap-3">
                  <Link to={`/services/${service.slug}`} className="bg-brand-amber hover:bg-brand-amber-dark text-white font-semibold py-3 px-6 rounded-lg text-sm cursor-pointer whitespace-nowrap transition-all">Full Details</Link>
                  <Link to="/contact" className="border border-stone-200 hover:border-brand-amber text-brand-dark hover:text-brand-amber font-semibold py-3 px-6 rounded-lg text-sm cursor-pointer whitespace-nowrap transition-all">Book Now</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-brand-dark">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">Not Sure Which Service You Need?</h2>
          <p className="text-white/70 text-lg mb-7 max-w-xl mx-auto">Call us and describe what you're experiencing. Our team will help you choose the right service for your home.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-brand-amber hover:bg-brand-amber-dark text-white font-bold py-3.5 px-8 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">Book Service</Link>
            <a href="tel:+19045550191" className="border-2 border-white/20 hover:border-white/50 text-white font-semibold py-3.5 px-8 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">Call (904) 555-0191</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
